<template>
    <div :class="[$style['mds-module-container']]" :data-mds-version="version">
        <slot></slot>
    </div>
</template>

<script>
    import packageInfo from '../package.json';
    const { name, version } = packageInfo;

    export default {
        name: 'MdsModuleContainer',
        props: {
            version: {
                type: String,
                default: `${name}-${version}`,
                docs: {
                    validation: 'Read-only',
                    description:
                        'Set automatically by package version, do not manually adjust this prop. Used to add a data attribute providing the component version to the component markup rendered in the DOM.',
                },
            },
        },
    };
</script>

<style lang="scss" module>
    @import './module-container.scss';
</style>
